import { isElectron } from '../utils/env'
import { getDesktopBridge } from './desktopBridge'

const UNAUTHENTICATED = {
  authenticated: false,
  user: null,
  subscription: null,
  usage: null,
  ideSessionId: null,
  governedRuntime: null,
  recentProjects: [],
}

export const authApi = {
  login(credentials) {
    if (isElectron()) {
      const bridge = getDesktopBridge()
      if (bridge) return bridge.auth.login(credentials)
    }
    // Browser mock login
    const mockSession = {
      authenticated: true,
      user: { email: credentials?.username || 'browser_user@example.com', full_name: 'Browser User' },
      subscription: null,
      usage: null,
      ideSessionId: 'browser-session-123',
      governedRuntime: null,
      recentProjects: [],
    }
    localStorage.setItem('arkitect_browser_session', JSON.stringify(mockSession))
    return Promise.resolve(mockSession)
  },
  logout() {
    if (isElectron()) {
      const bridge = getDesktopBridge()
      if (bridge) return bridge.auth.logout()
    }
    // Browser mock logout
    localStorage.removeItem('arkitect_browser_session')
    return Promise.resolve({ success: true })
  },
  restoreSession() {
    if (isElectron()) {
      const bridge = getDesktopBridge()
      if (bridge) return bridge.auth.restoreSession()
    }
    // Browser mock restore
    try {
      const stored = localStorage.getItem('arkitect_browser_session')
      if (stored) return Promise.resolve(JSON.parse(stored))
    } catch (e) {
      // ignore parsing errors
    }
    return Promise.resolve(UNAUTHENTICATED)
  },
  refreshIdeSession() {
    if (isElectron()) {
      const bridge = getDesktopBridge()
      if (bridge) return bridge.auth.refreshIdeSession()
    }
    return Promise.resolve({ success: false })
  },
}
